import React from 'react';
import { useParams } from 'react-router-dom';
import ProdutoService from '../services/ProdutoService';
import { Rating } from 'primereact/rating';
import { Button } from 'primereact/button';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import PedidoService from '../services/PedidoService';
import { hideProcess, showProcess } from '../utils/utils';
import iconEye from '../img/icon-eye.svg'

function withParams(Component) {
    return props => <Pedido {...props} params={useParams()} />;
}

class Pedido extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            pedidos: []
            
        }
    }

    async componentDidMount(){    
        try{
                
            await showProcess();

            const response = await PedidoService.getById(this.props.params.id);
            
            this.setState({pedido: response.data.object});
            

        }catch(e){
            alert(e)
        }
        
        hideProcess();
        
    }

    formatNumeric = (value) => {
        try{

            let USReal = new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 2
            });
        
            return USReal.format(value)
        
        }catch(e){
            return "0,00"
        }
    }

    render() {
        if (this.state.pedido !== undefined)
        return(
            <div style={{margin: '20px 5%'}}>
                <div style={{backgroundColor: "#ffffff", marginBottom: '40px', boxShadow: "rgba(0, 0, 0, 0.35) 0px 1px 5px"}}>
                    <div style={{padding: '10px', borderBottom: '1px solid #DCDCDC'}}>
                        RESUMO:
                    </div>
                    <div style={{padding: '10px'}}>
                        <table>
                            <tr>
                                <td style={{width: '105px'}}>
                                    Nº pedido: 
                                </td>
                                <td>
                                    {this.state.pedido.id}
                                </td>
                            </tr>
                            <tr>
                                <td style={{width: '70px'}}>
                                    Status: 
                                </td>
                                <td>
                                    {status[this.state.pedido.status]}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Data: 
                                </td>
                                <td>
                                    {new Date(this.state.pedido.criadoEm).getDay()} de {meses[new Date(this.state.pedido.criadoEm).getMonth() + 1]} de {new Date(this.state.pedido.criadoEm).getFullYear()} às {new Date(this.state.pedido.criadoEm).toLocaleTimeString()}
                                </td>
                            </tr>
                            {["B", "D", "E"].includes(this.state.pedido.status) &&
                                  <tr>
                                      <td >
                                          Processado Em: 
                                      </td>
                                      <td>
                                          {new Date(this.state.pedido.processadoEm).toLocaleDateString()} às {new Date(this.state.pedido.processadoEm).toLocaleTimeString()}
                                      </td>
                                  </tr>
                              }

                              {this.state.pedido.status === "C" &&
                                  <tr>
                                      <td >
                                          Rejeitado Em: 
                                      </td>
                                      <td>
                                          {new Date(this.state.pedido.rejeitadoEm).toLocaleDateString()} às {new Date(this.state.pedido.rejeitadoEm).toLocaleTimeString()}
                                      </td>
                                  </tr>
                              }

                              {this.state.pedido.status === "D" &&
                                  <tr>
                                      <td >
                                          Cancelado Em: 
                                      </td>
                                      <td>
                                          {new Date(this.state.pedido.canceladoEm).toLocaleDateString()} às {new Date(this.state.pedido.canceladoEm).toLocaleTimeString()}
                                      </td>
                                  </tr>
                              }

                              {this.state.pedido.status === "B" &&
                                  <tr>
                                      <td >
                                          Previsão Entrega: 
                                      </td>
                                      <td>
                                          {new Date(this.state.pedido.previsaoEntrega).toLocaleDateString()}
                                      </td>
                                  </tr>
                              }

                              {["B", "E"].includes(this.state.pedido.status) && 
                                <tr>
                                    <td>
                                        Valor: 
                                    </td>
                                    <td>
                                        {"R$ "+this.formatNumeric(this.state.pedido.itens.reduce((accumulator, q) => accumulator + (q.quantidade * q.valor),0,))}
                                    </td>
                                </tr>
                               }
                        </table>
                        
                    </div>

                </div>

                {this.state.pedido.itens.map((item, index) => 
                    <table style={{width: '100%'}} className='app-item-cart'>
                        <tr>
                            <td rowSpan={4} style={{width: '100px'}}><img src={item.produto.imagem !== null ? item.produto.imagem : require('../img/no-image.jpeg')} style={{height: '100px', objectFit: 'contain', backgroundColor: '#ffffff'}}/></td>
                            <td style={{textAlign: 'left'}}>{item.produto.nome}</td>
                        </tr>
                        <tr>
                            <td style={{textAlign: 'left'}}>
                                Quantidade: {item.quantidade}
                            </td>
                        </tr>
                        {["B", "E"].includes(this.state.pedido.status) &&
                            <>
                                <tr>
                                    <td style={{textAlign: 'left', borderBottom: '1px solid black'}}>
                                        Valor: {"R$ " + this.formatNumeric(item.valor)}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{textAlign: 'left'}}>
                                        Total: {"R$ " + this.formatNumeric(item.valor * item.quantidade)}
                                    </td>
                                </tr>
                            </>
                            
                        }
                        
                        
                    </table>    
                )}
                
            </div>
        );
        
    }


}

const meses = {
    "1": "Janeiro",
    "2": "Fevereiro",
    "3": "Março",
    "4": "Abril",
    "5": "Maio",
    "6": "Junho",
    "7": "Julho",
    "8": "Agosto",
    "9": "Setembro",
    "10": "Outubro",
    "11": "Novembro",
    "12": "Dezembro",
}

const status = {
    "A": "EM ANALISE",
    "B": "CONFIRMADO",
    "C": "REJEITADO",
    "D": "CANCELADO",
    "E": "FINALIZADO"
}

export default withParams(Pedido);
